// import React, { useState, useEffect } from 'react';
// import { getAuthToken } from '../../Config/api';
// import styles from './AuditTrail.module.css';

// function AuditTrail() {
//     const [auditLogs, setAuditLogs] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [actionFilter, setActionFilter] = useState('All Actions');
//     const [currentPage, setCurrentPage] = useState(1);
//     const [rowsPerPage, setRowsPerPage] = useState(10);
//     const [totalRecords, setTotalRecords] = useState(0);
//     const [message, setMessage] = useState({ text: '', type: '' });

//     const BACKEND_URL = 'https://lulliconazole.onrender.com/api/audit';


//     const fetchAuditLogs = async () => {
//         setLoading(true);
//         try {
//             const token = getAuthToken();
//             const params = {
//                 page: currentPage,
//                 limit: rowsPerPage,
//                 search: searchTerm,
//                 actionType: actionFilter !== 'All Actions' ? actionFilter : ''
//             };

//             const response = await fetch(`https://lulliconazole.onrender.com/api/audit/get-audit-logs`, {
//                 method: 'POST',
//                 body: JSON.stringify(params),
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'application/json'
//                 }
//             });

//             if (!response.ok) throw new Error('Failed to fetch audit logs');

//             const data = await response.json();
//             setAuditLogs(data.data || []);
//             setTotalRecords(data.totalRecords || 0);
//         } catch (error) {
//             console.error('Error fetching audit logs:', error);
//             setMessage({ text: `Error: ${error.message}`, type: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const downloadExcel = async () => {
//         setLoading(true);
//         setMessage({ text: '', type: '' });

//         try {
//             const token = getAuthToken();
//             const response = await fetch(`${BACKEND_URL}/download`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`
//                 },
//                 body: JSON.stringify({ type: 'xlsx' })
//             });

//             if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

//             const blob = await response.blob();
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;

//             const date = new Date().toISOString().split('T')[0];
//             link.download = `audit-trail-${date}.xlsx`;

//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);

//             setMessage({ text: 'Downloaded successfully!', type: 'success' });
//             setTimeout(() => setMessage({ text: '', type: '' }), 3000);

//         } catch (error) {
//             setMessage({ text: `Failed: ${error.message}`, type: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const formatTimestamp = (timestamp) => {
//         return new Date(timestamp).toLocaleString('en-US', {
//             year: 'numeric',
//             month: 'short',
//             day: '2-digit',
//             hour: '2-digit',
//             minute: '2-digit',
//             second: '2-digit'
//         });
//     };

//     const totalPages = Math.ceil(totalRecords / rowsPerPage);

//     useEffect(() => {
//         fetchAuditLogs();
//     }, [currentPage, rowsPerPage, searchTerm, actionFilter]);
//     return (
//         <div className={styles.container}>
//             <div className={styles.header}>
//                 <div>
//                     <h1 className={styles.title}>Audit Trail</h1>
//                     <p className={styles.subtitle}>Complete system activity and security logs</p>
//                 </div>
//                 <button
//                     className={styles.exportButton}
//                     onClick={downloadExcel}
//                     disabled={loading}
//                 >
//                     <span className={styles.buttonIcon}>↓</span>
//                     {loading ? 'Exporting...' : 'Export Logs'}
//                 </button>
//             </div>

//             {message.text && (
//                 <div className={`${styles.message} ${message.type === 'success' ? styles.messageSuccess : styles.messageError}`}>
//                     {message.text}
//                 </div>
//             )}

//             <div className={styles.searchBar}>
//                 <div className={styles.searchWrapper}>
//                     <svg className={styles.searchIcon} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                         <circle cx="11" cy="11" r="8" />
//                         <path d="m21 21-4.35-4.35" />
//                     </svg>
//                     <input
//                         type="text"
//                         className={styles.searchInput}
//                         placeholder="Search logs..."
//                         value={searchTerm}
//                         onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
//                     />
//                 </div>
//                 <div className={styles.actionButtons}>
//                     <select
//                         className={styles.filterSelect}
//                         value={actionFilter}
//                         onChange={(e) => { setActionFilter(e.target.value); setCurrentPage(1); }}
//                     >
//                         <option value="All Actions">All Actions</option>
//                         <option value="CREATE">Create</option>
//                         <option value="UPDATE">Update</option>
//                         <option value="DELETE">Delete</option>
//                         <option value="LOGIN">Login</option>
//                         <option value="LOGOUT">Logout</option>
//                         <option value="VIEW">View</option>
//                     </select>
//                 </div>
//             </div>

//             <div className={styles.tableWrapper}>
//                 {loading ? (
//                     <div style={{ textAlign: 'center', padding: '40px', fontSize: '16px', color: '#666' }}>
//                         Loading audit logs...
//                     </div>
//                 ) : auditLogs.length === 0 ? (
//                     <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
//                         No audit logs found
//                     </div>
//                 ) : (
//                     <table className={styles.table}>
//                         <thead className={styles.tableHead}>
//                             <tr>
//                                 <th>User Name</th>
//                                 <th>Role</th>
//                                 <th>Module</th>
//                                 <th>Action Type</th>
//                                 {/* <th>Field Name</th> */}
//                                 {/* <th>Old Value</th>
//                                 <th>New Value</th> */}
//                                 <th>IP Address</th>
//                                 <th>Timestamp</th>
//                                 <th>Remarks</th>
//                             </tr>
//                         </thead>
//                         <tbody className={styles.tableBody}>
//                             {auditLogs.map((log, index) => (
//                                 <tr key={log.audit_id || index} className={styles.tableRow}>
//                                     <td>{log.full_name || '-'}</td>
//                                     <td><span className={styles.roleBadge}>{log.role_name || '-'}</span></td>
//                                     <td>{log.module_name || '-'}</td>
//                                     <td><span className={styles.actionBadge}>{log.action_type || '-'}</span></td>
//                                     {/* <td>{log.field_name || '-'}</td>
//                                     <td>{log.old_value || '-'}</td>
//                                     <td>{log.new_value || '-'}</td> */}
//                                     <td>{log.ip_address || '-'}</td>
//                                     <td>{formatTimestamp(log.timestamp)}</td>
//                                     <td>{log.remark || '-'}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 )}
//             </div>

//             <div className={styles.pagination}>
//                 <div className={styles.rowsPerPage}>
//                     <span>Rows per page</span>
//                     <select
//                         className={styles.rowsSelect}
//                         value={rowsPerPage}
//                         onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}
//                     >
//                         <option value={10}>10</option>
//                         <option value={25}>25</option>
//                         <option value={50}>50</option>
//                         <option value={100}>100</option>
//                     </select>
//                 </div>
//                 <div className={styles.pageInfo}>
//                     Page {currentPage} of {totalPages || 1} ({totalRecords} total)
//                 </div>
//                 <div className={styles.pageControls}>
//                     <button
//                         className={styles.pageButton}
//                         onClick={() => setCurrentPage(1)}
//                         disabled={currentPage === 1}
//                     >
//                         ««
//                     </button>
//                     <button
//                         className={styles.pageButton}
//                         onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
//                         disabled={currentPage === 1}
//                     >
//                         ‹
//                     </button>
//                     <button
//                         className={styles.pageButton}
//                         onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
//                         disabled={currentPage === totalPages}
//                     >
//                         ›
//                     </button>
//                     <button
//                         className={styles.pageButton}
//                         onClick={() => setCurrentPage(totalPages)}
//                         disabled={currentPage === totalPages}
//                     >
//                         »»
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// }

// // export default AuditTrail;


// import React, { useState, useEffect } from 'react';
// import { getAuthToken } from '../../Config/api';
// import { MdClose } from 'react-icons/md';
// import { FiInfo } from 'react-icons/fi';
// import styles from './AuditTrail.module.css';

// function AuditTrail() {
//     const [auditLogs, setAuditLogs] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [actionFilter, setActionFilter] = useState('All Actions');
//     const [currentPage, setCurrentPage] = useState(1);
//     const [rowsPerPage, setRowsPerPage] = useState(10);
//     const [totalRecords, setTotalRecords] = useState(0);
//     const [message, setMessage] = useState({ text: '', type: '' });
//     const [slidingPanel, setSlidingPanel] = useState({
//         isOpen: false,
//         data: null,
//         loading: false
//     });

//     const BACKEND_URL = 'https://lulliconazole.onrender.com/api/audit';

//     const fetchAuditLogs = async () => {
//         setLoading(true);
//         try {
//             const token = getAuthToken();
//             const params = {
//                 page: currentPage,
//                 limit: rowsPerPage,
//                 search: searchTerm,
//                 actionType: actionFilter !== 'All Actions' ? actionFilter : ''
//             };

//             const response = await fetch(`https://lulliconazole.onrender.com/api/audit/get-audit-logs`, {
//                 method: 'POST',
//                 body: JSON.stringify(params),
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'application/json'
//                 }
//             });

//             if (!response.ok) throw new Error('Failed to fetch audit logs');

//             const data = await response.json();
//             setAuditLogs(data.data || []);
//             setTotalRecords(data.totalRecords || 0);
//         } catch (error) {
//             console.error('Error fetching audit logs:', error);
//             setMessage({ text: `Error: ${error.message}`, type: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchAuditDetails = async (auditId) => {
//         try {
//             setSlidingPanel({ isOpen: true, data: null, loading: true });
//             const token = getAuthToken();
//             const response = await fetch(`${BACKEND_URL}/get-audit-details`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`
//                 },
//                 body: JSON.stringify({ auditId })
//             });

//             if (!response.ok) {
//                 setSlidingPanel({ isOpen: true, data: { changes: [] }, loading: false });
//                 return;
//             }

//             const data = await response.json();

//             if (data.success) {
//                 setSlidingPanel({ isOpen: true, data: data.data, loading: false });
//             } else {
//                 setSlidingPanel({ isOpen: true, data: { changes: [] }, loading: false });
//             }
//         } catch (error) {
//             console.error('Error fetching audit details:', error);
//             setSlidingPanel({ isOpen: true, data: { changes: [] }, loading: false });
//         }
//     };

//     const closeSlidingPanel = () => {
//         setSlidingPanel({ isOpen: false, data: null, loading: false });
//     };

//     const downloadExcel = async () => {
//         setLoading(true);
//         setMessage({ text: '', type: '' });

//         try {
//             const token = getAuthToken();
//             const response = await fetch(`${BACKEND_URL}/download`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`
//                 },
//                 body: JSON.stringify({ type: 'xlsx' })
//             });

//             if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

//             const blob = await response.blob();
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;

//             const date = new Date().toISOString().split('T')[0];
//             link.download = `audit-trail-${date}.xlsx`;

//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);

//             setMessage({ text: 'Downloaded successfully!', type: 'success' });
//             setTimeout(() => setMessage({ text: '', type: '' }), 3000);

//         } catch (error) {
//             setMessage({ text: `Failed: ${error.message}`, type: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const formatTimestamp = (timestamp) => {
//         return new Date(timestamp).toLocaleString('en-US', {
//             year: 'numeric',
//             month: 'short',
//             day: '2-digit',
//             hour: '2-digit',
//             minute: '2-digit',
//             second: '2-digit'
//         });
//     };

//     const totalPages = Math.ceil(totalRecords / rowsPerPage);

//     useEffect(() => {
//         fetchAuditLogs();
//     }, [currentPage, rowsPerPage, searchTerm, actionFilter]);

//     return (
//         <div className={styles.container}>
//             <div className={styles.header}>
//                 <div>
//                     <h1 className={styles.title}>Audit Trail</h1>
//                     <p className={styles.subtitle}>Complete system activity and security logs</p>
//                 </div>
//                 <button
//                     className={styles.exportButton}
//                     onClick={downloadExcel}
//                     disabled={loading}
//                 >
//                     <span className={styles.buttonIcon}>↓</span>
//                     {loading ? 'Exporting...' : 'Export Logs'}
//                 </button>
//             </div>

//             {message.text && (
//                 <div className={`${styles.message} ${message.type === 'success' ? styles.messageSuccess : styles.messageError}`}>
//                     {message.text}
//                 </div>
//             )}

//             <div className={styles.searchBar}>
//                 <div className={styles.searchWrapper}>
//                     <svg className={styles.searchIcon} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                         <circle cx="11" cy="11" r="8" />
//                         <path d="m21 21-4.35-4.35" />
//                     </svg>
//                     <input
//                         type="text"
//                         className={styles.searchInput}
//                         placeholder="Search logs..."
//                         value={searchTerm}
//                         onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
//                     />
//                 </div>
//                 <div className={styles.actionButtons}>
//                     <select
//                         className={styles.filterSelect}
//                         value={actionFilter}
//                         onChange={(e) => { setActionFilter(e.target.value); setCurrentPage(1); }}
//                     >
//                         <option value="All Actions">All Actions</option>
//                         <option value="CREATE">Create</option>
//                         <option value="UPDATE">Update</option>
//                         <option value="DELETE">Delete</option>
//                         <option value="LOGIN">Login</option>
//                         <option value="LOGOUT">Logout</option>
//                         <option value="VIEW">View</option>
//                     </select>
//                 </div>
//             </div>

//             <div className={styles.tableWrapper}>
//                 {loading ? (
//                     <div style={{ textAlign: 'center', padding: '40px', fontSize: '16px', color: '#666' }}>
//                         Loading audit logs...
//                     </div>
//                 ) : auditLogs.length === 0 ? (
//                     <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
//                         No audit logs found
//                     </div>
//                 ) : (
//                     <table className={styles.table}>
//                         <thead className={styles.tableHead}>
//                             <tr>
//                                 <th>User Name</th>
//                                 <th>Role</th>
//                                 <th>Module</th>
//                                 <th>Action Type</th>
//                                 <th>IP Address</th>
//                                 <th>Timestamp</th>
//                                 <th>Remarks</th>
//                                 <th>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody className={styles.tableBody}>
//                             {auditLogs.map((log, index) => (
//                                 <tr key={log.audit_id || index} className={styles.tableRow}>
//                                     <td>{log.full_name || '-'}</td>
//                                     <td><span className={styles.roleBadge}>{log.role_name || '-'}</span></td>
//                                     <td>{log.module_name || '-'}</td>
//                                     <td><span className={styles.actionBadge}>{log.action_type || '-'}</span></td>
//                                     <td>{log.ip_address || '-'}</td>
//                                     <td>{formatTimestamp(log.timestamp)}</td>
//                                     <td>{log.remark || '-'}</td>
//                                     <td>
//                                         <button
//                                             className={styles.infoButton}
//                                             onClick={() => fetchAuditDetails(log.audit_id)}
//                                             title="View Details"
//                                         >
//                                             <FiInfo />
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 )}
//             </div>

//             <div className={styles.pagination}>
//                 <div className={styles.rowsPerPage}>
//                     <span>Rows per page</span>
//                     <select
//                         className={styles.rowsSelect}
//                         value={rowsPerPage}
//                         onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}
//                     >
//                         <option value={10}>10</option>
//                         <option value={25}>25</option>
//                         <option value={50}>50</option>
//                         <option value={100}>100</option>
//                     </select>
//                 </div>
//                 <div className={styles.pageInfo}>
//                     Page {currentPage} of {totalPages || 1} ({totalRecords} total)
//                 </div>
//                 <div className={styles.pageControls}>
//                     <button
//                         className={styles.pageButton}
//                         onClick={() => setCurrentPage(1)}
//                         disabled={currentPage === 1}
//                     >
//                         ««
//                     </button>
//                     <button
//                         className={styles.pageButton}
//                         onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
//                         disabled={currentPage === 1}
//                     >
//                         ‹
//                     </button>
//                     <button
//                         className={styles.pageButton}
//                         onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
//                         disabled={currentPage === totalPages}
//                     >
//                         ›
//                     </button>
//                     <button
//                         className={styles.pageButton}
//                         onClick={() => setCurrentPage(totalPages)}
//                         disabled={currentPage === totalPages}
//                     >
//                         »»
//                     </button>
//                 </div>
//             </div>

//             {slidingPanel.isOpen && (
//                 <>
//                     <div className={styles.overlay} onClick={closeSlidingPanel}></div>
//                     <div className={styles.slidingPanel}>
//                         <div className={styles.panelHeader}>
//                             <h2>Audit Details</h2>
//                             <button className={styles.closeButton} onClick={closeSlidingPanel}>
//                                 <MdClose />
//                             </button>
//                         </div>
//                         <div className={styles.panelContent}>
//                             {slidingPanel.loading ? (
//                                 <div className={styles.panelLoading}>
//                                     <div className={styles.spinner}></div>
//                                     <p>Loading details...</p>
//                                 </div>
//                             ) : slidingPanel.data && slidingPanel.data.changes && slidingPanel.data.changes.length > 0 ? (
//                                 <div className={styles.changesContainer}>
//                                     {slidingPanel.data.changes.map((change, index) => (
//                                         <div key={index} className={styles.changeItem}>
//                                             <h4 className={styles.fieldName}>{change.field_name || '-'}</h4>
//                                             <div className={styles.valueComparison}>
//                                                 <div className={styles.oldValue}>
//                                                     <span className={styles.valueLabel}>Old Value:</span>
//                                                     <span className={styles.valueText}>{change.old_value || '-'}</span>
//                                                 </div>
//                                                 <div className={styles.arrow}>→</div>
//                                                 <div className={styles.newValue}>
//                                                     <span className={styles.valueLabel}>New Value:</span>
//                                                     <span className={styles.valueText}>{change.new_value || '-'}</span>
//                                                 </div>
//                                             </div>
//                                             <div className={styles.changeMetadata}>
//                                                 <span>Updated: {formatTimestamp(change.timestamp)}</span>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             ) : (
//                                 <div className={styles.noChanges}>
//                                     <p>No changes found for this audit log</p>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </>
//             )}
//         </div>
//     );
// }

// export default AuditTrail;

// import React, { useState, useEffect } from 'react';
// import { getAuthToken } from '../../Config/api';
// import { MdClose } from 'react-icons/md';
// import { FiInfo } from 'react-icons/fi';
// import styles from './AuditTrail.module.css';

// function AuditTrail() {
//     const [auditLogs, setAuditLogs] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [actionFilter, setActionFilter] = useState('All Actions');
//     const [currentPage, setCurrentPage] = useState(1);
//     const [rowsPerPage, setRowsPerPage] = useState(10);
//     const [totalRecords, setTotalRecords] = useState(0);
//     const [message, setMessage] = useState({ text: '', type: '' });
//     const [slidingPanel, setSlidingPanel] = useState({
//         isOpen: false,
//         data: null,
//         loading: false
//     });

//     const BACKEND_URL = 'https://lulliconazole.onrender.com/api/audit';

//     const fetchAuditLogs = async () => {
//         setLoading(true);
//         try {
//             const token = getAuthToken();
//             const params = {
//                 page: currentPage,
//                 limit: rowsPerPage,
//                 search: searchTerm,
//                 actionType: actionFilter !== 'All Actions' ? actionFilter : ''
//             };

//             const response = await fetch(`https://lulliconazole.onrender.com/api/audit/get-audit-logs`, {
//                 method: 'POST',
//                 body: JSON.stringify(params),
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'application/json'
//                 }
//             });

//             if (!response.ok) throw new Error('Failed to fetch audit logs');

//             const data = await response.json();
//             setAuditLogs(data.data || []);
//             setTotalRecords(data.totalRecords || 0);
//         } catch (error) {
//             console.error('Error fetching audit logs:', error);
//             setMessage({ text: `Error: ${error.message}`, type: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchAuditDetails = async (auditId) => {
//         try {
//             setSlidingPanel({ isOpen: true, data: null, loading: true });
//             const token = getAuthToken();
//             const response = await fetch(`${BACKEND_URL}/get-audit-details`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`
//                 },
//                 body: JSON.stringify({ auditId })
//             });

//             if (!response.ok) {
//                 setSlidingPanel({ isOpen: true, data: { diff: [] }, loading: false });
//                 return;
//             }

//             const data = await response.json();

//             if (data.success) {
//                 setSlidingPanel({ isOpen: true, data: data.data, loading: false });
//             } else {
//                 setSlidingPanel({ isOpen: true, data: { diff: [] }, loading: false });
//             }
//         } catch (error) {
//             console.error('Error fetching audit details:', error);
//             setSlidingPanel({ isOpen: true, data: { diff: [] }, loading: false });
//         }
//     };

//     const closeSlidingPanel = () => {
//         setSlidingPanel({ isOpen: false, data: null, loading: false });
//     };

//     const downloadExcel = async () => {
//         setLoading(true);
//         setMessage({ text: '', type: '' });

//         try {
//             const token = getAuthToken();
//             const response = await fetch(`${BACKEND_URL}/download`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`
//                 },
//                 body: JSON.stringify({ type: 'xlsx' })
//             });

//             if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

//             const blob = await response.blob();
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;

//             const date = new Date().toISOString().split('T')[0];
//             link.download = `audit-trail-${date}.xlsx`;

//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);

//             setMessage({ text: 'Downloaded successfully!', type: 'success' });
//             setTimeout(() => setMessage({ text: '', type: '' }), 3000);

//         } catch (error) {
//             setMessage({ text: `Failed: ${error.message}`, type: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const formatTimestamp = (timestamp) => {
//         return new Date(timestamp).toLocaleString('en-US', {
//             year: 'numeric',
//             month: 'short',
//             day: '2-digit',
//             hour: '2-digit',
//             minute: '2-digit',
//             second: '2-digit'
//         });
//     };

//     const totalPages = Math.ceil(totalRecords / rowsPerPage);

//     useEffect(() => {
//         fetchAuditLogs();
//     }, [currentPage, rowsPerPage, searchTerm, actionFilter]);

//     return (
//         <div className={styles.container}>
//             <div className={styles.header}>
//                 <div>
//                     <h1 className={styles.title}>Audit Trail</h1>
//                     <p className={styles.subtitle}>Complete system activity and security logs</p>
//                 </div>
//                 <button
//                     className={styles.exportButton}
//                     onClick={downloadExcel}
//                     disabled={loading}
//                 >
//                     <span className={styles.buttonIcon}>↓</span>
//                     {loading ? 'Exporting...' : 'Export Logs'}
//                 </button>
//             </div>

//             {message.text && (
//                 <div className={`${styles.message} ${message.type === 'success' ? styles.messageSuccess : styles.messageError}`}>
//                     {message.text}
//                 </div>
//             )}

//             <div className={styles.searchBar}>
//                 <div className={styles.searchWrapper}>
//                     <svg className={styles.searchIcon} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                         <circle cx="11" cy="11" r="8" />
//                         <path d="m21 21-4.35-4.35" />
//                     </svg>
//                     <input
//                         type="text"
//                         className={styles.searchInput}
//                         placeholder="Search logs..."
//                         value={searchTerm}
//                         onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
//                     />
//                 </div>
//                 <div className={styles.actionButtons}>
//                     <select
//                         className={styles.filterSelect}
//                         value={actionFilter}
//                         onChange={(e) => { setActionFilter(e.target.value); setCurrentPage(1); }}
//                     >
//                         <option value="All Actions">All Actions</option>
//                         <option value="CREATE">Create</option>
//                         <option value="UPDATE">Update</option>
//                         <option value="DELETE">Delete</option>
//                         <option value="LOGIN">Login</option>
//                         <option value="LOGOUT">Logout</option>
//                         <option value="VIEW">View</option>
//                     </select>
//                 </div>
//             </div>

//             <div className={styles.tableWrapper}>
//                 {loading ? (
//                     <div style={{ textAlign: 'center', padding: '40px', fontSize: '16px', color: '#666' }}>
//                         Loading audit logs...
//                     </div>
//                 ) : auditLogs.length === 0 ? (
//                     <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
//                         No audit logs found
//                     </div>
//                 ) : (
//                     <table className={styles.table}>
//                         <thead className={styles.tableHead}>
//                             <tr>
//                                 <th>User Name</th>
//                                 <th>Role</th>
//                                 <th>Module</th>
//                                 <th>Action Type</th>
//                                 <th>IP Address</th>
//                                 <th>Timestamp</th>
//                                 <th>Remarks</th>
//                                 <th>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody className={styles.tableBody}>
//                             {auditLogs.map((log, index) => (
//                                 <tr key={log.audit_id || index} className={styles.tableRow}>
//                                     <td>{log.full_name || '-'}</td>
//                                     <td><span className={styles.roleBadge}>{log.role_name || '-'}</span></td>
//                                     <td>{log.module_name || '-'}</td>
//                                     <td><span className={styles.actionBadge}>{log.action_type || '-'}</span></td>
//                                     <td>{log.ip_address || '-'}</td>
//                                     <td>{formatTimestamp(log.timestamp)}</td>
//                                     <td>{log.remark || '-'}</td>
//                                     <td>
//                                         <button
//                                             className={styles.infoButton}
//                                             onClick={() => fetchAuditDetails(log.audit_id)}
//                                             title="View Details"
//                                         >
//                                             <FiInfo />
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 )}
//             </div>

//             <div className={styles.pagination}>
//                 <div className={styles.rowsPerPage}>
//                     <span>Rows per page</span>
//                     <select
//                         className={styles.rowsSelect}
//                         value={rowsPerPage}
//                         onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}
//                     >
//                         <option value={10}>10</option>
//                         <option value={25}>25</option>
//                         <option value={50}>50</option>
//                         <option value={100}>100</option>
//                     </select>
//                 </div>
//                 <div className={styles.pageInfo}>
//                     Page {currentPage} of {totalPages || 1} ({totalRecords} total)
//                 </div>
//                 <div className={styles.pageControls}>
//                     <button
//                         className={styles.pageButton}
//                         onClick={() => setCurrentPage(1)}
//                         disabled={currentPage === 1}
//                     >
//                         ««
//                     </button>
//                     <button
//                         className={styles.pageButton}
//                         onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
//                         disabled={currentPage === 1}
//                     >
//                         ‹
//                     </button>
//                     <button
//                         className={styles.pageButton}
//                         onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
//                         disabled={currentPage === totalPages}
//                     >
//                         ›
//                     </button>
//                     <button
//                         className={styles.pageButton}
//                         onClick={() => setCurrentPage(totalPages)}
//                         disabled={currentPage === totalPages}
//                     >
//                         »»
//                     </button>
//                 </div>
//             </div>

//             {slidingPanel.isOpen && (
//                 <>
//                     <div className={styles.overlay} onClick={closeSlidingPanel}></div>
//                     <div className={styles.slidingPanel}>
//                         <div className={styles.panelHeader}>
//                             <h2>Audit Details</h2>
//                             <button className={styles.closeButton} onClick={closeSlidingPanel}>
//                                 <MdClose />
//                             </button>
//                         </div>
//                         <div className={styles.panelContent}>
//                             {slidingPanel.loading ? (
//                                 <div className={styles.panelLoading}>
//                                     <div className={styles.spinner}></div>
//                                     <p>Loading details...</p>
//                                 </div>
//                             ) : slidingPanel.data ? (
//                                 <>
//                                     <div className={styles.auditInfo}>
//                                         <div className={styles.infoRow}>
//                                             <span className={styles.infoLabel}>User Name:</span>
//                                             <span className={styles.infoValue}>{slidingPanel.data.user_name || '-'}</span>
//                                         </div>
//                                         <div className={styles.infoRow}>
//                                             <span className={styles.infoLabel}>Role:</span>
//                                             <span className={styles.infoValue}>{slidingPanel.data.role || '-'}</span>
//                                         </div>
//                                         <div className={styles.infoRow}>
//                                             <span className={styles.infoLabel}>Module:</span>
//                                             <span className={styles.infoValue}>{slidingPanel.data.module || '-'}</span>
//                                         </div>
//                                         <div className={styles.infoRow}>
//                                             <span className={styles.infoLabel}>Action Type:</span>
//                                             <span className={styles.actionBadgePanel}>{slidingPanel.data.action_type || '-'}</span>
//                                         </div>
//                                         <div className={styles.infoRow}>
//                                             <span className={styles.infoLabel}>Timestamp:</span>
//                                             <span className={styles.infoValue}>{formatTimestamp(slidingPanel.data.timestamp)}</span>
//                                         </div>
//                                         <div className={styles.infoRow}>
//                                             <span className={styles.infoLabel}>Remark:</span>
//                                             <span className={styles.infoValue}>{slidingPanel.data.remark || '-'}</span>
//                                         </div>
//                                     </div>

//                                     {slidingPanel.data.diff && slidingPanel.data.diff.length > 0 ? (
//                                         <div className={styles.changesContainer}>
//                                             <h3 className={styles.changesTitle}>Changes Made</h3>
//                                             {slidingPanel.data.diff.map((change, index) => (
//                                                 <div key={index} className={styles.changeItem}>
//                                                     <h4 className={styles.fieldName}>{change.field_name || '-'}</h4>
//                                                     <div className={styles.valueComparison}>
//                                                         <div className={styles.oldValue}>
//                                                             <span className={styles.valueLabel}>Old Value:</span>
//                                                             <span className={styles.valueText}>{change.old_value || '-'}</span>
//                                                         </div>
//                                                         <div className={styles.arrow}>→</div>
//                                                         <div className={styles.newValue}>
//                                                             <span className={styles.valueLabel}>New Value:</span>
//                                                             <span className={styles.valueText}>{change.new_value || '-'}</span>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     ) : (
//                                         <div className={styles.noChanges}>
//                                             <p>No changes found for this audit log</p>
//                                         </div>
//                                     )}
//                                 </>
//                             ) : (
//                                 <div className={styles.noChanges}>
//                                     <p>No data available</p>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </>
//             )}
//         </div>
//     );
// }

// export default AuditTrail;

import React, { useState, useEffect } from 'react';
import { getAuthToken } from '../../Config/api';
import { MdClose } from 'react-icons/md';
import { FiInfo } from 'react-icons/fi';
import styles from './AuditTrail.module.css';

function AuditTrail() {
    const [auditLogs, setAuditLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [actionFilter, setActionFilter] = useState('All Actions');
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [message, setMessage] = useState({ text: '', type: '' });
    const [slidingPanel, setSlidingPanel] = useState({
        isOpen: false,
        data: null,
        loading: false
    });

    const BACKEND_URL = 'https://lulliconazole.onrender.com/api/audit';

    const fetchAuditLogs = async () => {
        setLoading(true);
        try {
            const token = getAuthToken();
            const params = {
                page: currentPage,
                limit: rowsPerPage,
                search: searchTerm,
                actionType: actionFilter !== 'All Actions' ? actionFilter : ''
            };

            const response = await fetch(`https://lulliconazole.onrender.com/api/audit/get-audit-logs`, {
                method: 'POST',
                body: JSON.stringify(params),
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) throw new Error('Failed to fetch audit logs');

            const data = await response.json();
            setAuditLogs(data.data || []);
            setTotalRecords(data.totalRecords || 0);
        } catch (error) {
            console.error('Error fetching audit logs:', error);
            setMessage({ text: `Error: ${error.message}`, type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const fetchAuditDetails = async (auditId) => {
        try {
            setSlidingPanel({ isOpen: true, data: null, loading: true });
            document.body.style.overflow = 'hidden';

            const token = getAuthToken();
            const response = await fetch(`${BACKEND_URL}/get-audit-details`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ audit_id: auditId })
            });

            if (!response.ok) {
                setSlidingPanel({ isOpen: true, data: { diff: [] }, loading: false });
                return;
            }

            const data = await response.json();

            if (data.success) {
                setSlidingPanel({ isOpen: true, data: data.data, loading: false });
            } else {
                setSlidingPanel({ isOpen: true, data: { diff: [] }, loading: false });
            }
        } catch (error) {
            console.error('Error fetching audit details:', error);
            setSlidingPanel({ isOpen: true, data: { diff: [] }, loading: false });
        }
    };

    const closeSlidingPanel = () => {
        setSlidingPanel({ isOpen: false, data: null, loading: false });
        document.body.style.overflow = 'unset';
    };

    const downloadExcel = async () => {
        setLoading(true);
        setMessage({ text: '', type: '' });

        try {
            const token = getAuthToken();
            const response = await fetch(`${BACKEND_URL}/download`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ type: 'xlsx' })
            });

            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            const date = new Date().toISOString().split('T')[0];
            link.download = `audit-trail-${date}.xlsx`;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            setMessage({ text: 'Downloaded successfully!', type: 'success' });
            setTimeout(() => setMessage({ text: '', type: '' }), 3000);

        } catch (error) {
            setMessage({ text: `Failed: ${error.message}`, type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const formatTimestamp = (timestamp) => {
        return new Date(timestamp).toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    };

    const totalPages = Math.ceil(totalRecords / rowsPerPage);

    useEffect(() => {
        fetchAuditLogs();
    }, [currentPage, rowsPerPage, searchTerm, actionFilter]);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div>
                    <h1 className={styles.title}>Audit Trail</h1>
                    <p className={styles.subtitle}>Complete system activity and security logs</p>
                </div>
                <button
                    className={styles.exportButton}
                    onClick={downloadExcel}
                    disabled={loading}
                >
                    <span className={styles.buttonIcon}>↓</span>
                    {loading ? 'Exporting...' : 'Export Logs'}
                </button>
            </div>

            {message.text && (
                <div className={`${styles.message} ${message.type === 'success' ? styles.messageSuccess : styles.messageError}`}>
                    {message.text}
                </div>
            )}

            <div className={styles.searchBar}>
                <div className={styles.searchWrapper}>
                    <svg className={styles.searchIcon} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="11" cy="11" r="8" />
                        <path d="m21 21-4.35-4.35" />
                    </svg>
                    <input
                        type="text"
                        className={styles.searchInput}
                        placeholder="Search logs..."
                        value={searchTerm}
                        onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                    />
                </div>
                {/* <div className={styles.actionButtons}>
                    <select
                        className={styles.filterSelect}
                        value={actionFilter}
                        onChange={(e) => { setActionFilter(e.target.value); setCurrentPage(1); }}
                    >
                        <option value="All Actions">All Actions</option>
                        <option value="CREATE">Create</option>
                        <option value="UPDATE">Update</option>
                        <option value="DELETE">Delete</option>
                        <option value="LOGIN">Login</option>
                        <option value="LOGOUT">Logout</option>
                        <option value="VIEW">View</option>
                    </select>
                </div> */}
            </div>

            <div className={styles.tableWrapper}>
                {loading ? (
                    <div style={{ textAlign: 'center', padding: '40px', fontSize: '16px', color: '#666' }}>
                        Loading audit logs...
                    </div>
                ) : auditLogs.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                        No audit logs found
                    </div>
                ) : (
                    <table className={styles.table}>
                        <thead className={styles.tableHead}>
                            <tr>
                                <th>User Name</th>
                                <th>Role</th>
                                <th>Module</th>
                                <th>Action Type</th>
                                <th>IP Address</th>
                                <th>Timestamp</th>
                                <th>Remarks</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody className={styles.tableBody}>
                            {auditLogs.map((log, index) => (
                                <tr key={log.audit_id || index} className={styles.tableRow}>
                                    <td>{log.full_name || '-'}</td>
                                    <td><span className={styles.roleBadge}>{log.role_name || '-'}</span></td>
                                    <td>{log.module_name || '-'}</td>
                                    <td><span className={styles.actionBadge}>{log.action_type || '-'}</span></td>
                                    <td>{log.ip_address || '-'}</td>
                                    <td>{formatTimestamp(log.timestamp)}</td>
                                    <td>{log.remark || '-'}</td>
                                    <td>
                                        <button
                                            className={styles.infoButton}
                                            onClick={() => fetchAuditDetails(log.audit_id)}
                                            title="View Details"
                                        >
                                            <FiInfo />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            <div className={styles.pagination}>
                <div className={styles.rowsPerPage}>
                    <span>Rows per page</span>
                    <select
                        className={styles.rowsSelect}
                        value={rowsPerPage}
                        onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>
                <div className={styles.pageInfo}>
                    Page {currentPage} of {totalPages || 1} ({totalRecords} total)
                </div>
                <div className={styles.pageControls}>
                    <button
                        className={styles.pageButton}
                        onClick={() => setCurrentPage(1)}
                        disabled={currentPage === 1}
                    >
                        ««
                    </button>
                    <button
                        className={styles.pageButton}
                        onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                        disabled={currentPage === 1}
                    >
                        ‹
                    </button>
                    <button
                        className={styles.pageButton}
                        onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                        disabled={currentPage === totalPages}
                    >
                        ›
                    </button>
                    <button
                        className={styles.pageButton}
                        onClick={() => setCurrentPage(totalPages)}
                        disabled={currentPage === totalPages}
                    >
                        »»
                    </button>
                </div>
            </div>

            {slidingPanel.isOpen && (
                <>
                    <div className={styles.overlay} onClick={closeSlidingPanel}></div>
                    <div className={styles.slidingPanel}>
                        <div className={styles.panelHeader}>
                            <h2>Audit Details</h2>
                            <button className={styles.closeButton} onClick={closeSlidingPanel}>
                                <MdClose />
                            </button>
                        </div>
                        <div className={styles.panelContent}>
                            {slidingPanel.loading ? (
                                <div className={styles.panelLoading}>
                                    <div className={styles.spinner}></div>
                                    <p>Loading details...</p>
                                </div>
                            ) : slidingPanel.data ? (
                                <>
                                    <div className={styles.auditInfo}>
                                        <div className={styles.infoRow}>
                                            <span className={styles.infoLabel}>User Name:</span>
                                            <span className={styles.infoValue}>{slidingPanel.data.full_name || '-'}</span>
                                        </div>
                                        <div className={styles.infoRow}>
                                            <span className={styles.infoLabel}>Role:</span>
                                            <span className={styles.infoValue}>{slidingPanel.data.role_name || '-'}</span>
                                        </div>
                                        <div className={styles.infoRow}>
                                            <span className={styles.infoLabel}>Module:</span>
                                            <span className={styles.infoValue}>{slidingPanel.data.module_name || '-'}</span>
                                        </div>
                                        <div className={styles.infoRow}>
                                            <span className={styles.infoLabel}>Action Type:</span>
                                            <span className={styles.actionBadgePanel}>{slidingPanel.data.action_type || '-'}</span>
                                        </div>
                                        <div className={styles.infoRow}>
                                            <span className={styles.infoLabel}>Timestamp:</span>
                                            <span className={styles.infoValue}>{formatTimestamp(slidingPanel.data.timestamp)}</span>
                                        </div>
                                        <div className={`${styles.infoRow} ${styles.remarkRow}`}>
                                            <span className={styles.infoLabel}>Remark:</span>
                                            <span className={styles.infoValue}>{slidingPanel.data.remark || '-'}</span>
                                        </div>
                                    </div>

                                    {slidingPanel.data.diff && slidingPanel.data.diff.length > 0 ? (
                                        <div className={styles.changesContainer}>
                                            <h3 className={styles.changesTitle}>Changes Made</h3>
                                            {slidingPanel.data.diff.map((change, index) => (
                                                <div key={index} className={styles.changeItem}>
                                                    <h4 className={styles.fieldName}>{change.field_name || '-'}</h4>
                                                    <div className={styles.valueComparison}>
                                                        <div className={styles.oldValue}>
                                                            <span className={styles.valueLabel}>Old Value:</span>
                                                            <span className={styles.valueText}>{change.old_value || '-'}</span>
                                                        </div>
                                                        <div className={styles.arrow}>→</div>
                                                        <div className={styles.newValue}>
                                                            <span className={styles.valueLabel}>New Value:</span>
                                                            <span className={styles.valueText}>{change.new_value || '-'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className={styles.noChanges}>
                                            <p>No changes found for this audit log</p>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className={styles.noChanges}>
                                    <p>No data available</p>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default AuditTrail;















